import styled from '@emotion/styled';
import {Drawer, List} from '@mui/material';
import {APP} from 'src/styles/variables';

export const LeftNavDrawerStyle = styled(Drawer)`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ListStyle = styled(List)`
  flex: 1;
  height: inherit;
  display: flex;
  flex-direction: column;
`;
export const CountBadge = styled(List)<{filterApplied: boolean}>`
  padding: 2px 5px;
  border-radius: 10px;
  font-size: 0.75em;
  font-weight: normal;
  color: ${APP.PALETTE.BADGE.TEXT_COLOR};
  border: 1px solid;
  background-color: ${({filterApplied}) =>
    filterApplied ? '' : `${APP.PALETTE.BADGE.BACKGROUND}`};
  border-color: ${({filterApplied}) =>
    filterApplied
      ? `${APP.PALETTE.BADGE.BORDER_COLOR}`
      : `${APP.PALETTE.BADGE.BACKGROUND}`};
`;
